import React, { useState, useRef, useEffect, Fragment } from "react";
import toogleEdit from "../assets/images/model/toogleEdit.svg";
import toogleNavegate from "../assets/images/model/toogleNavegate.svg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const stringToArray = (str) => str.split(" "); // Split by space
const removeHtmlTags = (text) => text.replace(/<\/?[^>]+>/gi, ""); // Remove HTML tags

const FillTheBlanks = ({
  setIsEditing,
  isEditing,
  question,
  handleBlankInput,
  setIsTotalBlanks,
  addBlankOption,
  handleAlternateAnswer
}) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const quillRef = useRef(null);
  const grey = "var(--Grey-900, #2E2E2D)";
  const highlightColor = "var(--Purple-200, #eeeaf6)";
  const [isToggled, setIsToggled] = useState(false);
  function checkTextVariations(text, questionBankQuestion) {
    const variations = [
      text,
      `${text}.`,
      `${text},`,
      `${text}'`,
      `${text}"`,
      `${text}?`,
      `${text}!`,
      `${text};`,
      `${text}:`,
      `${text}\n`,
      `${text}\t`, //leading space
      `${text}-`,
      `${text}_`,
      `${text}(`,
      `${text})`,
      `${text}[`,
      `${text}]`,
      `${text}<`,
      `${text}>`,
      `${text}/`,
      `${text}\\`,
      `${text}|`,
      `${text}@`,
      `${text}#`,
      `${text}$`,
      `${text}%`,
      `${text}^`,
      `${text}&`,
      `${text}*`,
      `${text}=`,
      `${text}+`,
      `${text}~`,
      `${text}` + String.fromCharCode(160), // non-breaking space
    ];

    for (const variation of variations) {
      if (questionBankQuestion.includes(variation)) {
        return true; // Variation found, return true
      }
    }

    return false; // No variations found, return false
  }
  const modules = {
    toolbar: {
      container: [["bold", "italic", "underline", "clean"]]
    }
  };
  const newline = question.bankQuestion.join(" ");
  const formats = ["bold", "italic", "underline", "color"];

  const handleSave = () => {
    if (question.blanksBank.length === 0) {
      setError(
        "At least 1 blank must be selected in order to save and continue."
      );
    } else {
      setError(""); // Clear error message
      setIsEditing(false);
      // setIsTotalBlanks(question.blanksBank.length); // Save the entire blanksBank
    }
  };
  useEffect(() => {
    const quill = quillRef.current.getEditor();

    // Intercept the paste event
    quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
      const ops = delta.ops.map((op) => {
        // Ensure only plain text is pasted, removing formatting
        return {
          insert: typeof op.insert === "string" ? op.insert : ""
        };
      });
      return {
        ops
      };
    });
  }, []);

  const handleToggle = () => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();

    if (range && range.length > 0) {
      let text = quill.getText(range.index, range.length).trim().toLowerCase();
const normalizedText = text.replace(/[.,'"!;:\\\/?]/g, '');
      // Check if the selected word is valid
     if (text && !question.bankQuestion?.some((e)=>e.replace(/[.,'"!;:\\\/?]/g, '')===text) &&  !question.bankQuestion?.includes(text)) {
        setError(
          "Please select an entire word without spaces and without dots!"
        );
        return;
      }

      setError("");
      const currentFormats = quill.getFormat(range.index, range.length);
      const currentColor = currentFormats.color;
      const newColor = currentColor === grey ? null : grey;

      // Apply or remove formatting to the selected text
      quill.formatText(range.index, range.length, {
        color: newColor,
        background: newColor ? highlightColor : null, // Set background to null if deselected
        borderRadius: newColor ? "3px" : null // Reset borderRadius if deselected
      });

      const occurrences = question.bankQuestion.reduce(
        (sumWords, currentWord, currentInedx) => {
          if (currentWord.replace(/[.,'"!;:\\\/?]/g, '') === text || currentWord===text) sumWords.push(currentInedx);
          return sumWords;
        },
        []
      );

      const alreadySelectedCount = question.blanksBank.filter(
        (entry) => entry.answers[0] === text
      ).length;

      const newIndexNo = occurrences[alreadySelectedCount];
      // Update the questions state
      addBlankOption(newIndexNo, range, text);

      setIsTotalBlanks(question.blanksBank.length);
      // Set the cursor position after the selected text
      quill.setSelection(range.index + range.length, 0);
      setIsToggled(true);

      // Reset toggle state after a short delay
      setTimeout(() => {
        setIsToggled(false);
      }, 800);
    }
  };

  return (
    <Fragment>
      <div className={`${isEditing ? `fill_in_the_blanks` : ` bold-border`}`}>
        <div className="mr-tp-bt create-view">
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={question.sentence}
            onChange={(e) => {
              handleBlankInput(e);
              setValue(e);
            }}
            modules={modules}
            formats={formats}
            readOnly={!isEditing}
            className={`class-value ${
              value.length === 0 ? "my-custom-quill " : ""
            } ${isToggled && "hide-toolbar fill_border"} ${
              isEditing ? "toolbar" : "toolbar_none"
            }`}
            placeholder="Start typing. Add line breaks for paragraphs or numbers to create a list. Click the toggle to add blanks."
          />
          {error && <div className="error_fill_in_blanks">{error}</div>}
          <div className="alternate_blank" style={{ margin: "8px 0px" }}>
            Add alternate answers to the bank
          </div>

          <>
            {question.blanksBank.map((item) => (
              <div
                key={item.indexNo}
                className="parent_input_with_image mcqs_border"
                style={{ marginBottom: "12px" }}>
                <div className="parent_input">
                  <textarea
                    className="orderlist-input alter_words"
                    rows={1}
                    onChange={(e) =>
                      handleAlternateAnswer(item.indexNo, e.target.value)
                    }
                    value={item.answers.join(", ")}
                    readOnly={!isEditing}
                  />
                </div>
              </div>
            ))}
          </>

          {isEditing ? (
            <>
              <div className="option-adder-wrapper mrt-12">
                <div className="Multiplechoice_wrap add_text_save">
                  <div className="parent_radio_button">
                    <div className="radio_button_check">
                      <div
                        className={`white_circle ${
                          isToggled && "toggled_switch"
                        }`}
                        onClick={() => {
                          handleToggle();
                        }}
                        style={{ cursor: "pointer" }}>
                        <img
                          src={isToggled ? toogleNavegate : toogleEdit}
                          alt="Toggle Button"
                        />
                      </div>
                    </div>
                    <div className="write_statment">
                      {isToggled
                        ? "Select or deselect blanks"
                        : "Write a statement"}
                    </div>
                  </div>
                  <div style={{ cursor: "pointer" }} onClick={handleSave}>
                    Save --{">"}
                  </div>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default FillTheBlanks;
